var _module_exports = "<div class=\"fancy-menu-details-title\">Rate</div>\n\n<p>\n  Calculates the rate per second of the given input stream.\n</p>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/RATE/description.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;